import { render, staticRenderFns } from "./NoForm.vue?vue&type=template&id=e6136500&"
import script from "./NoForm.vue?vue&type=script&lang=js&"
export * from "./NoForm.vue?vue&type=script&lang=js&"
import style0 from "./NoForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports